module.exports = __webpack_public_path__ + "static/img/SearchDetailOperate4.9901f1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/QRcode/SearchDetailOperate4.png
// module id = 763
// module chunks = 0